export default __webpack_public_path__ + "static/media/folder-svgrepo-com.4922dc71.svg";